<div *ngIf="shouldShow(question)"
     [ngSwitch]="question.type"
     class="relative">
  <label [for]="id" class="form-label">
    {{question.label | replace: '{REPORT}' : reportName}} {{question.required ? '*' : ''}}
    <span class="info-icon">
      <mat-icon *ngIf="question.tooltip" [matTooltip]="question.tooltip">info_outline</mat-icon>
    </span>
  </label>

  <em *ngIf="question.description != null" class="small mb10 block">{{question.description}}</em>

  <!-- DATE -->
  <div *ngSwitchCase="'DATE'" class="w800" [ngClass]="{'input-error': valid(name)}">
    <input type="date"
           [id]="id"
           #name="ngModel"
           [required]="required()"
           [name]="id"
           [(ngModel)]="model[id]"
           (ngModelChange)="onChange()">
    <div class="errors" *ngIf="valid(name)">
      <div *ngIf="name.errors?.required">Dit veld is verplicht.</div>
    </div>
  </div>

  <!-- SELECT -->
  <div *ngSwitchCase="'SELECT'" class="w800" [ngClass]="{'input-error': valid(name)}">
    <app-select [options]="question.choices"
                valueIndex="name"
                #name="ngModel"
                [name]="id"
                [required]="required()"
                [(ngModel)]="model[id]"
                (ngModelChange)="onChange()"
                [labelFormatter]="selectLabelFormatter"></app-select>
    <div class="errors" *ngIf="valid(name)">
      <div *ngIf="name.errors?.required">Dit veld is verplicht.</div>
    </div>
  </div>

  <!-- MULTI_SELECT -->
  <div *ngSwitchCase="'MULTI_SELECT'">
    <div *ngFor="let choice of question.choices" [ngClass]="{'input-error': valid(name)}">
    <label>
      <input type="checkbox"
             #name="ngModel"
             [required]="required()"
             [(ngModel)]="model[id][choice.name]"
             (ngModelChange)="onChange()"
             [name]="model[id] + choice.name">
      {{choice.value | replace: '{REPORT}' : reportName}}
    </label>
      <div class="errors" *ngIf="valid(name)">
        <div *ngIf="name.errors?.required">Dit veld is verplicht.</div>
      </div>
    </div>
  </div>

  <!-- BIG_TEXT -->
  <div *ngSwitchCase="'BIG_TEXT'" class="w800" [ngClass]="{'input-error': valid(name)}">
    <textarea [id]="id"
              #name="ngModel"
              [name]="id"
              [required]="required()"
              [(ngModel)]="model[id]"
              (ngModelChange)="onChange()"></textarea>
    <div class="errors" *ngIf="valid(name)">
      <div *ngIf="name.errors?.required">Dit veld is verplicht.</div>
    </div>
  </div>

  <!-- POST_DECIMAL -->
  <div *ngSwitchCase="'POST_DECIMAL'">
    <div class="euro-field DECIMAL_BOEDEL flex" *ngIf="reportTypeCode === 'BB'">
      <div [ngClass]="{'input-error': !name.valid}">
        <input appIpecialIsAlphaNumeric
               style="width: 470px; margin-right: 30px;"
               type="text"
               pattern="^[0-9]+(\.[0-9]{1,2})?$"
               #name="ngModel"
               [id]="id"
               [name]="id + 'value'"
               [(ngModel)]="model[id]['value']"
               (ngModelChange)="calculate()"/>
        <div class="errors" *ngIf="!name.valid">
          <div *ngIf="name.errors?.pattern">het verzoek een punt te gebruiken in plaats van een komma</div>
        </div>
      </div>
      <app-select [options]="postDecimalOptions"
                  [small]="true"
                  [name]="id + 'period'"
                  [(ngModel)]="model[id]['period']"
                  (ngModelChange)="calculate()">
      </app-select>
      <label class="postDecimalCalculations">{{getMonthlyValue(model[id]['value'], model[id]['period'])}}</label>
    </div>
  </div>

  <!-- DECIMAL -->
  <div *ngSwitchCase="'DECIMAL'" class="w800 euro-field" [ngClass]="{'input-error': valid(name)}">
    <input appIpecialIsAlphaNumeric
           #name="ngModel"
           pattern="^[0-9]+(\.[0-9]{1,2})?$"
           [required]="required()"
           type="text"
           [id]="id"
           [name]="id"
           [(ngModel)]="model[id]"
           (ngModelChange)="onChange()"/>
    <div class="errors" *ngIf="valid(name)">
      <div *ngIf="name.errors?.required">Dit veld is verplicht.</div>
      <div *ngIf="name.errors?.pattern">Het verzoek een punt te gebruiken in plaats van een komma.</div>
    </div>
  </div>

  <!-- SMALL TEXT -->
  <div *ngSwitchCase="'SMALL_TEXT'" class="w800" [ngClass]="{'input-error': valid(name)}">
    <input type="text"
           #name="ngModel"
           [required]="required()"
           [readOnly]="readOnly()"
           [id]="id"
           [name]="id"
           [(ngModel)]="model[id]"
           (ngModelChange)="onChange()">
    <div class="errors" *ngIf="valid(name)">
      <div *ngIf="name.errors?.required">Dit veld is verplicht.</div>
    </div>
  </div>

  <!-- IBAN -->
  <div *ngSwitchCase="'IBAN'" class="w800" [ngClass]="{'input-error': valid(name)}">
    <input type="text"
           #name="ngModel"
           [required]="required()"
           [readOnly]="readOnly()"
           [id]="id"
           app-iban
           [name]="id"
           [(ngModel)]="model[id]"
           (ngModelChange)="onChange()">
    <div class="errors" *ngIf="valid(name)">
      <div *ngIf="name.errors?.required">Dit veld is verplicht.</div>
      <div *ngIf="name.errors?.validAccountNumber">Geen geldig IBAN</div>
    </div>
  </div>

  <!-- LIST -->
  <div *ngSwitchCase="'LIST'">
    <table class="full-width report-table">
      <thead>
      <tr>
        <th *ngFor="let subQuestion of question.subQuestions; let i = index" [ngClass]="{'pl40': i !== 0}">
            {{subQuestion.label}}
            <mat-icon class="info-icon"
                      *ngIf="subQuestion.tooltip"
                      [matTooltip]="subQuestion.tooltip">
              info_outline
            </mat-icon>
        </th>
      </tr>
      </thead>
      <tbody>
        <tr *ngFor="let tmp of model[id]; let i = index">
          <td *ngFor="let subQuestion of question.subQuestions; let j = index">

            <div [ngSwitch]="subQuestion.type">
              <div *ngSwitchCase="'SMALL_TEXT'" [ngClass]="{'input-error': valid(name)}">
                <input [class]="{'small-input': j !== 0}"
                       type="text"
                       #name="ngModel"
                       [required]="requiredSubquestion(model[id][i])"
                       [name]="subQuestion.identification + i"
                       [(ngModel)]="model[id][i][subQuestion.identification]"
                       (ngModelChange)="onChange()">
                <div class="errors" *ngIf="valid(name)" [ngClass]="{'pl40': j !== 0}">
                  <div *ngIf="name.errors?.required">Dit veld is verplicht.</div>
                </div>
              </div>

              <div *ngSwitchCase="'DECIMAL'" class="euro-field" [ngClass]="{'input-error': valid(name), 'small-euro-field': j !== 0}">
                <input appIpecialIsAlphaNumeric
                       [class]="{'small-input': j !== 0}"
                       type="text"
                       #name="ngModel"
                       pattern="^[0-9]+(\.[0-9]{1,2})?$"
                       [required]="requiredSubquestion(model[id][i])"
                       [name]="subQuestion.identification + i"
                       [(ngModel)]="model[id][i][subQuestion.identification]"
                       (ngModelChange)="onChange()">
                <div class="errors" *ngIf="valid(name)" [ngClass]="{'pl40': j !== 0}">
                  <div *ngIf="name.errors?.required">Dit veld is verplicht.</div>
                  <div *ngIf="name.errors?.pattern">Het verzoek een punt te gebruiken in plaats van een komma.</div>
                </div>
              </div>

              <div *ngSwitchCase="'SELECT'"  [ngClass]="{'input-error': valid(name)}">
                <app-select [options]="question.choices"
                            valueIndex="name"
                            [small]="true"
                            [name]="subQuestion.identification + i"
                            #name="ngModel"
                            [required]="requiredSubquestion(model[id][i])"
                            [(ngModel)]="model[id][i][subQuestion.identification]"
                            (ngModelChange)="onChange()"
                            [labelFormatter]="selectLabelFormatter"></app-select>
                <div class="errors" *ngIf="valid(name)" [ngClass]="{'pl40': j !== 0}">
                  <div *ngIf="name.errors?.required">Dit veld is verplicht.</div>
                </div>
              </div>

              <div *ngSwitchCase="'DATE'"  [ngClass]="{'input-error': valid(name)}">
                <input [class]="{'small-input': j !== 0}"
                       type="text"
                       #name="ngModel"
                       [required]="requiredSubquestion(model[id][i])"
                       [name]="subQuestion.identification + i"
                       [(ngModel)]="model[id][i][subQuestion.identification]"
                       (ngModelChange)="onChange()">
                <div class="errors" *ngIf="valid(name)" [ngClass]="{'pl40': j !== 0}">
                  <div *ngIf="name.errors?.required">Dit veld is verplicht.</div>
                </div>
              </div>

              <!-- IBAN -->
              <div *ngSwitchCase="'IBAN'" [ngClass]="{'input-error': valid(name)}">
                <input [class]="{'small-input': j !== 0}"
                       type="text"
                       #name="ngModel"
                       [required]="requiredSubquestion(model[id][i])"
                       app-iban
                       [name]="subQuestion.identification + i"
                       [(ngModel)]="model[id][i][subQuestion.identification]"
                       (ngModelChange)="onChange()">
                <div class="errors" *ngIf="valid(name)" [ngClass]="{'pl40': j !== 0}">
                  <div *ngIf="name.errors?.required">Dit veld is verplicht.</div>
                  <div *ngIf="name.errors?.validAccountNumber">Geen geldig IBAN</div>
                </div>
              </div>

            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <span class="btn plus btn-left mt14 mb14" (click)="addRow()">rij aanmaken</span>
  </div>

  <!-- INDICATOR -->
  <div *ngSwitchCase="'INDICATOR'"  [ngClass]="{'input-error': valid(name)}">
    <div>
    <label>
      <input type="radio"
             #name="ngModel"
             value="1"
             [required]="required()"
             [name]="id"
             [(ngModel)]="model[id]"
             (ngModelChange)="onChange()"/>Ja
    </label>
    </div>
    <div>
    <label>
      <input type="radio"
             #name="ngModel"
             value="0"
             [required]="required()"
             [name]="id"
             [(ngModel)]="model[id]"
             (ngModelChange)="onChange()"/>Nee
    </label>
  </div>
    <div class="errors" *ngIf="valid(name)">
      <div *ngIf="name.errors?.required">Dit veld is verplicht.</div>

    </div>
  </div>
</div>
